import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';
import { message as andMessage } from 'antd';
import history from '../../history';
import {
  getWebCards,
  getWebCard,
  deleteWebCards,
  postWebCards,
  putWebCards,
  bulkPutWebCards,
} from '../../services/webCards';
import {
  REQUEST_WEB_CARDS,
  REQUEST_WEB_CARDS_SUCCESS,
  REQUEST_WEB_CARDS_FAIL,
  REQUEST_WEB_CARD,
  REQUEST_WEB_CARD_SUCCESS,
  REQUEST_WEB_CARD_FAIL,
  DELETE_WEB_CARD,
  DELETE_WEB_CARD_SUCCESS,
  DELETE_WEB_CARD_FAIL,
  CREATE_WEB_CARD,
  CREATE_WEB_CARD_SUCCESS,
  CREATE_WEB_CARD_FAIL,
  UPDATE_WEB_CARD,
  UPDATE_WEB_CARD_SUCCESS,
  UPDATE_WEB_CARD_FAIL,
  SORT_WEB_CARD,
  SORT_WEB_CARD_SUCCESS,
  SORT_WEB_CARD_FAIL,
} from '../actionTypes';
import { dataListSelector } from '../selectors/webCards';

function* fetchWebCards(action) {
  try {
    const data = yield call(getWebCards);
    yield put({ type: REQUEST_WEB_CARDS_SUCCESS, payload: { data } });
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: REQUEST_WEB_CARDS_FAIL, payload: message });
  }
}

function* fetchWebCard(action) {
  try {
    const data = yield call(getWebCard, action.payload);
    yield put({ type: REQUEST_WEB_CARD_SUCCESS, payload: data });
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: REQUEST_WEB_CARD_FAIL, payload: message });
  }
}

function* removeWebCard({ payload: id }) {
  try {
    yield call(deleteWebCards, id);
    yield put({ type: DELETE_WEB_CARD_SUCCESS, payload: id });
    andMessage.success('Web Card was removed satisfactorily');
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: DELETE_WEB_CARD_FAIL, payload: message });
  }
}

function* createWebCard({ payload: data }) {
  try {
    const createdData = yield call(postWebCards, data);
    yield put({ type: CREATE_WEB_CARD_SUCCESS, payload: createdData });
    history.push('/cards');
    andMessage.success('Web Card was created satisfactorily');
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: CREATE_WEB_CARD_FAIL, payload: message });
  }
}

function* updateWebCard({ payload: { id, data } }) {
  try {
    const newData = yield call(putWebCards, id, data);
    yield put({ type: UPDATE_WEB_CARD_SUCCESS, payload: { id, data: newData } });
    history.push('/cards');
    andMessage.success('Web Card was updated satisfactorily');
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: UPDATE_WEB_CARD_FAIL, payload: message });
  }
}

function* sortWebCard({ payload: { oldIndex, newIndex } }) {
  try {
    const webCardsList = yield select(dataListSelector);
    const from = Math.min(oldIndex, newIndex);
    const to = Math.max(oldIndex, newIndex) + 1;
    const updatedWebCards = webCardsList
      .slice(from, to)
      .map((webCard, order) => ({ ...webCard, order: order + from + 1 }));

    yield call(bulkPutWebCards, updatedWebCards);
    const updatedWebCardsObject = updatedWebCards.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {});
    yield put({ type: SORT_WEB_CARD_SUCCESS, payload: updatedWebCardsObject });
    andMessage.success('Web Card was sorted satisfactorily');
  } catch (errorResponse) {
    const message = errorResponse.message || (yield errorResponse.json()).message;

    andMessage.error(message);
    yield put({ type: SORT_WEB_CARD_FAIL, payload: { message, oldIndex, newIndex } });
  }
}

function* webCardsSaga() {
  yield takeLatest(REQUEST_WEB_CARDS, fetchWebCards);
  yield takeLatest(REQUEST_WEB_CARD, fetchWebCard);
  yield takeLatest(DELETE_WEB_CARD, removeWebCard);
  yield takeLatest(CREATE_WEB_CARD, createWebCard);
  yield takeLatest(UPDATE_WEB_CARD, updateWebCard);
  yield takeLatest(SORT_WEB_CARD, sortWebCard);
}

export default webCardsSaga;
